import React from 'react'
import InfoModal from '../common/Modals/InfoModal';
import { isCardExpired } from '../../helper';
const getCardTypeName = (type) => {
    const typeMap = {
        'american express': 'AmericanExpress',
        'visa electron': 'Visa',
        'visa': 'Visa',
        'mastercard': 'MasterCard',
        'discover': 'Discover',
        'china_unionpay': 'Unionpay',
        'diners club': 'DinersClub',
        'dinersclub': 'DinersClub'
    };

    return typeMap[type.toLowerCase()] || 'Visa';
}

const CreditCard = ({ item, customerPaymentProfileId, setCustomerPaymentProfileId, setCustomerPaymentProfileIdErr,
    handlePrimaryCard, handleDeleteCard }) => {
    const isDeleted = item.card?.metadata?.deleted ?? false
    const name = item.card.name;
    const expired = isCardExpired(Number(item.card.month), Number(item.card.year))
    const checked = !isDeleted && !expired && customerPaymentProfileId === item.card.token
    const isDisabled = (isDeleted || expired);
    const badgeText = isDeleted ? "DELETED" : expired ? "EXPIRED" : ""

    return (
        <div className='d-flex justify-content-between text-black' >

            <div style={{ display: 'flex', alignItems: 'center',  }}>
                {!isDisabled ? <div className="check_box_wrapper cm_dark_check pt-1">
                    <input
                        disabled={isDisabled}
                        checked={checked}
                        onChange={() => (setCustomerPaymentProfileId(item.card.token), setCustomerPaymentProfileIdErr(''))}
                        type="radio"
                        name="gender"
                        value="male" />
                    <span className="check_box"><span></span></span>
                </div> : <div className="check_box_wrapper cm_dark_check pt-1"></div>}
                <div className="p_card_img ms-2">
                    <img src={item?.card?.brand ? require(`../../assets/img/${getCardTypeName(item.card.brand)}.svg`) : require(`../../assets/img/Visa.svg`)} alt="" />
                </div>
                <div className='d-flex flex-column'>
                    <small>{name}</small>
                    <span className='primary-card-text'>********{item.card.acct_last_four}</span>
                </div>

            </div>
            {<div className='primary-card-content'>
                { !isDisabled && (!(item.card?.primary) ?
                    <>

                        <div className="check_box_wrapper cm_dark_check">
                            <input
                                disabled={isDisabled}
                                checked={item?.card?.metadata?.primary}
                                onClick={item?.card?.metadata?.primary ? "" : () => handlePrimaryCard(item.card.token)}
                                type="radio"
                            />
                            <span className="check_box"><span></span></span>
                        </div>
                        <span className='primary-card-text'>set as primary</span>
                    </>
                    :
                    <span className={`primary-card-text btn-primary`}>Primary Card</span>)

                }
                <div className="">{!isDeleted ? <i onClick={() => handleDeleteCard(item.card.token)} className="icon-delete" style={{ fontSize: "24px" }} /> : <i style={{ fontSize: "24px" }} />}</div>
            </div>}
            {(isDisabled) &&
                <div className='has_top_right_badge'>
                    <small className={`badge badge-pill ${isDeleted ? 'bkg-primary' : expired ? 'bg-warning' : ""}`}>{badgeText}</small>
                </div>
            }


        </div>
    )
}

export default CreditCard
